import { render, staticRenderFns } from "./ResponsibleView.vue?vue&type=template&id=23f39506&scoped=true"
import script from "./ResponsibleView.vue?vue&type=script&lang=js"
export * from "./ResponsibleView.vue?vue&type=script&lang=js"
import style0 from "./ResponsibleView.vue?vue&type=style&index=0&id=23f39506&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f39506",
  null
  
)

export default component.exports